import { StorageKeys, UserRoles, UserRolesAccessLevels } from "@/utils/consts";
import Vue from "vue";
import { SweetAlertIcon, SweetAlertOptions, SweetAlertResult } from "sweetalert2";
import { User } from "@/types/user";
import { isEqual, isObject, transform } from "lodash";
import router from "@/router";
import moment, { Moment } from "moment";
import { MediaObject } from "@/types/mediaObject";
import { storage_url } from "@/api/apiCall";
import { RoomAvailability } from "@/types/availability";
import { Room, RoomServiceType } from "@/types/room";
import { RoomCapacity, RoomVariant, RoomVariantClassification } from "@/types/roomVariant";
import { Pricing, RoomPricing } from "@/types/pricing";
import { Language } from "@/types/language";
import i18n from "@/i18n/i18n";
import VueI18n from "vue-i18n/types/index";
import { getHotelPrice, Hotel } from "@/types/hotel";
import Decimal from "decimal.js";

// extremely hacky typescript compatible getdeepprop, try not to use it much
export function getDeepProp<T>(obj: unknown, path: string): T {
    let current: unknown = obj;

    const paths = path.split(".");

    // Get to the proper key
    for (let i = 0; i < paths.length; i++) {
        current = (current as Record<string, unknown>)[paths[i]];
    }

    return current as T;
}

export async function readFileToDataUrl(file: File): Promise<unknown> {
    return new Promise(resolve => {
        const reader = new FileReader();

        reader.onload = function (e) {
            resolve(e.target?.result);
        };

        reader.readAsDataURL(file);
    });
}

//
//
// export function mergeName(user) {
//     return [user?.first_name, user?.middle_name, user?.last_name].filter(v => Boolean(v)).join(' ');
// }
//
// //diffs two objects
// export function difference(object, base) {
//     function changes(object, base) {
//         return transform(object, function (result, value, key) {
//             if (!isEqual(value, base[key])) {
//                 result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
//             }
//         });
//     }
//
//     return changes(object, base);
// }
//
// export function splitName(name) {
//     let data = {};
//     let nameParts = name.split(' ');
//     data.first_name = nameParts[0];
//     nameParts.splice(0, 1);
//     data.last_name = nameParts.join(' ');
//     return data;
// }
//
export function getAccessLevel(user: User): UserRolesAccessLevels {
    if (user.roles.includes(UserRoles.ROLE_SUPER_ADMIN)) {
        return UserRolesAccessLevels.ROLE_SUPER_ADMIN;
    } else if (user.roles.includes(UserRoles.ROLE_AGENCY_ADMIN)) {
        return UserRolesAccessLevels.ROLE_AGENCY_ADMIN;
    } else if (user.roles.includes(UserRoles.ROLE_USER)) {
        return UserRolesAccessLevels.ROLE_USER;
    }

    return 0;
}

export function showSwalToast(message: string, type: SweetAlertIcon = "error"): void {
    Vue.swal({
        toast: true,
        position: "top-end",
        timer: 3500,
        title: message,
        icon: type,
        showConfirmButton: false,
    });
}


export function showAreYouSureSwal(options?: SweetAlertOptions, language: Language = Language.bs): Promise<SweetAlertResult> {
    const defaultOptions = {
        title: i18n.tc("are_you_sure", 0, language),
        text: "Are you sure you want to do this?",
        icon: "warning",
    };

    const actualOptions = Object.assign(defaultOptions, options);

    return Vue.swal<boolean>({
        title: actualOptions.title,
        text: actualOptions.text,
        icon: actualOptions.icon,
        showCancelButton: true,
        confirmButtonColor: "#cd5c5c",
        cancelButtonColor: "#d8d8d8",
        confirmButtonText: i18n.tc("confirm"),
        cancelButtonText: i18n.tc("cancel"),
        reverseButtons: true,
    });
}

//
// export function showSuccessSwal() {
//     Vue.swal({
//         toast: true,
//         position: 'top-end',
//         timer: 2500,
//         title: 'Uspješno',
//         icon: 'success',
//         showConfirmButton: false,
//     });
// }
//
// export function checkIfMobile() {
//     let check = false;
//     (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
//     return check;
// }

//diffs two objects
export function difference(object: Record<string, any>, base: Record<string, any>): Record<string, any> {
    function changes(object: Record<string, any>, base: Record<string, any>) {
        return transform(object, function (result: Record<string, any>, value, key) {
            if (!isEqual(value, base[key])) {
                result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
            }
        });
    }

    return changes(object, base);
}

export function goBackOrPush(route: string): void {

    router.push(route);

    // if (uiModule.previousRoute === route) {
    //
    // } else {
    //     router.push(route);
    // }
}

export function getDatesBetweenRangeInclusive({
                                                  startDate,
                                                  endDate,
                                              }: { startDate: Moment, endDate: Moment }): Array<Moment> {
    const dateArray: Array<Moment> = [];
    let currentDate = startDate.clone();

    while (currentDate <= endDate) {
        dateArray.push(currentDate.clone());
        currentDate = currentDate.add(1, "day");
    }

    return dateArray;
}

export function pickRandomSubarray<T>(array: Array<T>, howMany: number): Array<T> {
    const max = array.length - 1;

    const retArr: Array<T> = [];
    const pickedIndexes: Array<number> = [];

    if (howMany > max) {
        return array;
    } else {
        while (retArr.length < howMany) {
            const index = Math.floor(Math.random() * max);
            if (!pickedIndexes.includes(index)) {
                retArr.push(array[index]);
                pickedIndexes.push(index);
            }
        }
    }

    return retArr;
}

export interface GenericName {
    firstName: string | null,
    middleName?: string | null,
    lastName: string | null,
}

export function mergeName(obj: GenericName): string {
    return [obj.firstName, obj.middleName, obj.lastName].filter(o => o !== null && o !== "" && o !== undefined).join(" ");
}

export function getStorageUrl(mediaObject: MediaObject | null): string {
    if (mediaObject === null) return "";
    return storage_url + mediaObject.contentUrl;
}

export function getThumbnailStorageUrl(mediaObject: MediaObject | null | undefined): string {
    if (!mediaObject || !mediaObject.thumbnail) return "";

    return storage_url + mediaObject.thumbnail.thumbnailUrl;
}

export function getRoomPriceGroups(room: Room, roomVariantClassification: RoomVariantClassification): Array<[number, number]> {
    const ret: Record<number, Array<RoomAvailability>> = [];

    if (room) {
        room.availabilities?.forEach(avail => {
            const price = getRoomVariantPricingObject(avail.pricing, roomVariantClassification)?.standard.adults ?? null;
            if (price !== null) {
                if (ret[price] !== undefined) {
                    ret[price].push(avail);
                } else {
                    ret[price] = [avail];
                }
            }
        });
    }

    return Object.entries(ret).map(([key, value]) => {
        return [+key, value.length];
    });
}

export function getRoomTotalPrice(room: Room, roomVariantClassification: RoomVariantClassification, roomServiceCost = 0): number {

    let total = 0;

    getRoomPriceGroups(room, roomVariantClassification).forEach(([key, value]) => {
        total += key * value;
    });

    return total + roomServiceCost;
}

export function getRoomVariantText(variant: string): string {
    switch (variant) {
        case RoomVariantClassification.SINGLE:
            return "Jednokrevetna";
        case RoomVariantClassification.DOUBLE:
            return "Dvokrevetna";
        case RoomVariantClassification.TRIPLE:
            return "Trokrevetna";
        case RoomVariantClassification.QUADRUPLE:
            return "Četverokrevetna";
        case RoomVariantClassification.QUINTUPLE:
            return "Petokrevetna";
        default:
            return "";
    }
}

export function getRoomVariantPricingObject(roomPricing: RoomPricing, roomVariantClassification: RoomVariantClassification): Pricing {
    switch (roomVariantClassification) {
        case RoomVariantClassification.SINGLE:
            return roomPricing.single;
        case RoomVariantClassification.DOUBLE:
            return roomPricing.double;
        case RoomVariantClassification.TRIPLE:
            return roomPricing.triple;
        case RoomVariantClassification.QUADRUPLE:
            return roomPricing.quadruple;
        case RoomVariantClassification.QUINTUPLE:
            return roomPricing.quintuple;
        default:
            return roomPricing.single;
    }
}

export function roundDecimals(num: number, places = 2): number {
    return +(Math.round(Number(num + "e+" + places)) + "e-" + places);
}

export function areDateRangesOverlapping(firstStartDate: Date, firstEndDate: Date, secondStartDate: Date, secondEndDate: Date): boolean {
    return (moment(firstStartDate).isSameOrBefore(moment(secondEndDate), "days")) && (moment(firstEndDate).isSameOrAfter(moment(secondStartDate), "days"));
}

// finds which one of the objects has a max total capacity, ie adults + children
export function getRoomVariantObjectMaxCapacities(variant: RoomVariant | null): RoomCapacity[] {
    if (!variant) return [];

    const { capacity, alternativeCapacity } = variant;

    const { capacity1, capacity2, capacity3 } = alternativeCapacity;

    const mainCapacity = ((capacity.adults ?? 0) + (capacity.children ?? 0));
    const alternative1 = ((capacity1.adults ?? 0) + (capacity1.children ?? 0));
    const alternative2 = ((capacity2.adults ?? 0) + (capacity2.children ?? 0));
    const alternative3 = ((capacity3.adults ?? 0) + (capacity3.children ?? 0));

    const maxCapacity = Math.max(mainCapacity, alternative1, alternative2, alternative3);

    const maxCapacities: RoomCapacity[] = [];

    if (mainCapacity >= maxCapacity) {
        maxCapacities.push(capacity);
    }
    if (alternative1 >= maxCapacity) {
        maxCapacities.push(capacity1);
    }
    if (alternative2 >= maxCapacity) {
        maxCapacities.push(capacity2);
    }
    if (alternative3 >= maxCapacity) {
        maxCapacities.push(capacity3);
    }

    return maxCapacities;
}

export function getRoomVariantChildrenCapacity(variant: RoomVariant | null): number {
    if (!variant) return 0;

    const { capacity, alternativeCapacity } = variant;

    return Math.max(capacity.children ?? 0, alternativeCapacity.capacity1.children ?? 0, alternativeCapacity.capacity2.children ?? 0, alternativeCapacity.capacity3.children ?? 0);
}

export function getRoomVariantAdultsCapacity(variant: RoomVariant | null): number {
    if (!variant) return 0;

    const { capacity, alternativeCapacity } = variant;

    return Math.max(capacity.adults ?? 0, alternativeCapacity.capacity1.adults ?? 0, alternativeCapacity.capacity2.adults ?? 0, alternativeCapacity.capacity3.adults ?? 0);
}

export enum SortOrder {
    ASC = "ASC",
    DESC = "DESC"
}

export function getCurrentLang(): Language {
    return localStorage.getItem(StorageKeys.LANGUAGE) as Language ?? Language.bs;
}

export function getRoomServiceTypeText(serviceType: string, i18n: VueI18n): string {
    if (!serviceType) {
        return "";
    }

    switch (serviceType) {
        case RoomServiceType.HALF_BOARD:
            return i18n.tc("half_board");
        case RoomServiceType.FULL_BOARD:
            return i18n.tc("full_board");
        case RoomServiceType.ALL_INCLUSIVE:
            return "All Inclusive";
        case RoomServiceType.BED_AND_BREAKFAST:
            return i18n.tc("bed_and_breakfast");
        case RoomServiceType.ULTRA_ALL_INCLUSIVE:
            return "Ultra All Inclusive";
    }

    return "";
}

export function getHotelLowestPrice(hotel: Hotel, adminMargin: number, agencyMarkup: number) {
    if (hotel) {
        const adminMarkup = hotel.margin ? hotel.margin : adminMargin;

        let basePriceD = new Decimal(getHotelPrice(hotel));

        if (agencyMarkup && agencyMarkup !== 0) {
            const agencyMarkupD = new Decimal(agencyMarkup).div(100).add(1);
            basePriceD = basePriceD.mul(agencyMarkupD);
        }

        if (adminMarkup && adminMarkup !== 0) {
            const adminMarkupD = new Decimal(adminMarkup).div(100).add(1);
            basePriceD = basePriceD.mul(adminMarkupD);
        }

        return basePriceD.toNumber();
    } else {
        return 0;
    }
}

export function sortHotelsByPrice(a: Hotel, b: Hotel, adminMarkup: number, agencyMarkup: number): number {
    const aPrice = getHotelLowestPrice(a, adminMarkup, agencyMarkup);
    const bPrice = getHotelLowestPrice(b, adminMarkup, agencyMarkup);

    return aPrice - bPrice;
}
